import { createContext } from 'react';

export type VersionExpectationStateType =
  | 'SATISFIED'
  | 'LOADING'
  | 'MINIMUM_OUTDATED'
  | 'REQUIRED_OUTDATED';

export interface VersionExpectationStateValue {
  state: VersionExpectationStateType;
  onIgnoreUpdate(): void;
}

export const VersionExpectationsContext =
  createContext<VersionExpectationStateValue>({
    onIgnoreUpdate: () => {},
    state: 'LOADING',
  });
